import React from 'react';

import { cn, ia, iaRa } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Switch from 'components/shared/Switch/Switch';

import TimeRangeSelector from './TimeRangeSelector';
import { useTimeUpdate } from './useTimeUpdate';

const TAB_LOCATION = 'location';
const TAB_VIRTUAL = 'virtual';

const TabButton = ({ isActive, onClick, label }) => {
  const className = cn(
    'cursor-pointer border-0 border-solid px-3 pb-2 text-sm font-500',
    isActive
      ? 'border-b-2 border-primary-500 text-primary-500'
      : 'border-b-[1px] border-neutral-200 text-neutral-800'
  );

  return (
    <div className={className} onClick={onClick}>
      {label}
    </div>
  );
};

const DayDetails = ({ day, updateAvailableTimes, activeTab, setActiveTab }) => {
  const currentTab = activeTab || TAB_LOCATION;
  const currentType = currentTab === TAB_LOCATION ? TAB_LOCATION : TAB_VIRTUAL;
  const current = day[currentType] || {};
  const hasBreaks = ia(day.break);

  const {
    handleTimeChange,
    handleAddBreak,
    handleBreakChange,
    handleRemoveBreak,
    handleBreakToggle
  } = useTimeUpdate({ day, updateAvailableTimes });

  return (
    <div className="flex flex-col gap-4 border-0 border-t border-solid border-neutral-200 bg-neutral-50 px-4 pb-4 pt-3">
      <div className="flex">
        <TabButton
          isActive={currentTab === TAB_LOCATION}
          onClick={() => setActiveTab(TAB_LOCATION)}
          label="Office"
        />
        <TabButton
          isActive={currentTab === TAB_VIRTUAL}
          onClick={() => setActiveTab(TAB_VIRTUAL)}
          label="Virtual"
        />
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <TimeRangeSelector
            label="Working hours"
            startValue={current.starts_at}
            endValue={current.ends_at}
            onStartChange={(value) => handleTimeChange(day.day, currentType, 'starts_at', value)}
            onEndChange={(value) => handleTimeChange(day.day, currentType, 'ends_at', value)}
          />
        </div>

        <div className="h-[1px] w-full bg-neutral-200" />

        <div className="flex flex-col gap-4 border-t border-neutral-100">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Switch checked={hasBreaks} onChange={handleBreakToggle} />
              <span className="text-sm font-400 text-neutral-900">Define work breaks</span>
            </div>
          </div>

          {hasBreaks && (
            <div className="flex flex-col gap-4">
              {iaRa(day.break).map((breakItem, index) => (
                <div key={breakItem.id} className="flex items-end gap-4">
                  <div className="flex-1">
                    <TimeRangeSelector
                      label={index === 0 ? 'Break hours' : ''}
                      startValue={breakItem.starts_at}
                      endValue={breakItem.ends_at}
                      onStartChange={(value) =>
                        handleBreakChange(day.day, breakItem.id, 'starts_at', value)
                      }
                      onEndChange={(value) =>
                        handleBreakChange(day.day, breakItem.id, 'ends_at', value)
                      }
                    />
                  </div>
                  <Icon
                    icon="trash-mono"
                    size={18}
                    onClick={() => handleRemoveBreak(day.day, breakItem.id)}
                    className="mb-3"
                  />
                </div>
              ))}

              <Button
                size="small"
                text="Add another work break"
                onClick={() => handleAddBreak(day.day)}
                variant="link"
                className="w-fit"
                icon="add-square-mono"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayDetails;
